import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface User {
  id: string;           // uid (Google ID 或 Facebook ID)，即 artistID
  name: string;         // stageName
  email: string;
  avatar?: string;      // profilePicture
  isRegistered: boolean;
  loginType?: 1 | 2;    // 1-google，2-facebook
  // Profile fields
  country?: string;
  genres?: string[];    // musicGenre
  moods?: string[];
  bio?: string;
  socialLinks?: {
    instagram?: string;
    twitter?: string;
    spotify?: string;
    apple?: string;
  };
}

interface UserState {
  user: User | null;
  
  // Actions
  setUser: (user: User) => void;
  updateUser: (updates: Partial<User>) => void;
  setRegistered: (registered: boolean) => void;
  logout: () => void;
  
  // Computed getters
  isLoggedIn: () => boolean;
  isRegistered: () => boolean;
  getArtistID: () => string;
  getLoginType: () => 1 | 2 | undefined;
}

export const useUserStore = create<UserState>()(
  persist(
    (set, get) => ({
      user: null,

      setUser: (user) => set({ user }),

      updateUser: (updates) => set((state) => ({
        user: state.user ? { ...state.user, ...updates } : null,
      })),

      setRegistered: (registered) => set((state) => ({
        user: state.user ? { ...state.user, isRegistered: registered } : null,
      })),

      logout: () => {
        set({ user: null });
        // window.location.replace(`${window.location.origin}/login`);
      },

      // Computed
      isLoggedIn: () => !!get().user,
      isRegistered: () => get().user?.isRegistered ?? false,
      getArtistID: () => get().user?.id || '',
      getLoginType: () => get().user?.loginType,
    }),
    {
      name: 'musichub-user-storage', // localStorage key
    }
  )
);

// 便捷函数，可在非组件中使用
export const getArtistID = () => useUserStore.getState().getArtistID();
export const getLoginType = () => useUserStore.getState().getLoginType();
export const getUserData = () => useUserStore.getState().user;
